import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/working_dir/Frontend/layouts/default.vue").then(m => m.default || m))
}